export default "__VITE_ASSET__ACZcfkAr__"